/**
 *  Copyright AlpineReplay Inc, 2021. All rights reserved.
 *  Authors: Slobodan Djordjevic
 */
import React, { useEffect, useState } from "react"
import TraceIDButton from "./TraceIDButton"
import * as links from "../util/links"
import {
    Color,
    Icon,
    VideoControlButton,
    VideoControls,
    Element,
    isSmallScreen,
    isSmallMobileScreen,
} from "trux"
import UserButton from "./UserButton"
import "./UserControls.css"

export const UserControls = (props) => {
    const [color, setColor] = useState(Color.Trace)

    const handleResize = () => {
        setColor(isSmallMobileScreen() ? Color.Trace : Color.White2)
    }

    useEffect(() => {
        setColor(isSmallMobileScreen() ? Color.Trace : Color.White2)

        window.addEventListener("resize", handleResize)
        return () => window.removeEventListener("resize", handleResize)
    }, [])

    return (
        <Element
            trkContext={props.trkContext}
            className={
                props.className
                    ? props.className + " UserControls"
                    : "UserControls"
            }
        >
            {!isSmallMobileScreen() && (
                <VideoControls>
                    <TraceIDButton
                        trkAction={
                            props.user
                                ? "Trace ID Pressed"
                                : "Trace ID Login Pressed"
                        }
                        user={props.user}
                        event={props.event}
                        saveUrl={links
                            .gameShareUrl(
                                props.teamName,
                                props.playlistId,
                                props.gameId,
                                props.eventNumber
                            )
                            .replace("share", "save/profile")}
                        history={props.history}
                        iconColor={color}
                        acl={props.acl}
                    />
                    <VideoControlButton
                        trkAction="Players Pressed"
                        icon={Icon.Type.PlayersGeneric}
                        iconColor={color}
                        onClick={(e) =>
                            props.history.push(
                                links.gamePlayersUrl(
                                    props.teamName,
                                    props.playlistId,
                                    props.gameId,
                                    props.eventNumber
                                )
                            )
                        }
                        iconSize="24"
                        hideSM
                        title="Players"
                    />
                    <VideoControlButton
                        trkAction="More Pressed"
                        icon={Icon.Type.More}
                        iconColor={color}
                        onClick={(e) =>
                            props.history.push(
                                links.gameOptionsUrl(
                                    props.teamName,
                                    props.playlistId,
                                    props.gameId,
                                    props.eventNumber
                                )
                            )
                        }
                        iconSize="24"
                        title="Highlight options"
                    />
                    {!isSmallScreen() && (
                        <UserButton
                            trkAction="User Pressed"
                            user={props.user}
                            event={props.event}
                            saveUrl={
                                props.user
                                    ? links
                                          .gameShareUrl(
                                              props.teamName,
                                              props.playlistId,
                                              props.gameId,
                                              props.eventNumber
                                          )
                                          .replace("share", "user/profile")
                                    : links
                                          .gameShareUrl(
                                              props.teamName,
                                              props.playlistId,
                                              props.gameId,
                                              props.eventNumber
                                          )
                                          .replace("share", "save/profile") +
                                      "/user"
                            }
                            history={props.history}
                        />
                    )}
                </VideoControls>
            )}
        </Element>
    )
}
